var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import isEqual from 'lodash/isEqual';
import unionBy from 'lodash/unionBy';
import memoize from 'memoize-one';
import { PureComponent } from 'react';
/**
 * An HOC to implement selection logic and provide them as props to the wrapped
 * component
 *
 * @param Component The wrapped component
 * @param uniqueIdentifier The unique field name of the Item type
 */
export const withSelection = (Component, uniqueIdentifier = 'name') => {
    class WithSelection extends PureComponent {
        constructor(props) {
            super(props);
            this.state = {
                selectedItems: [],
            };
            this.memoizedGetInjectedProps = memoize(this.memoizedGetInjectedProps, isEqual).bind(this); // We have to bind it like this. Using @boundMethod won't work
        }
        handleSetSelectedItems(items) {
            this.setState({ selectedItems: items });
        }
        handleSelectItem(item) {
            this.setState(({ selectedItems }) => ({
                selectedItems: unionBy(selectedItems, [item], uniqueIdentifier),
            }));
        }
        handleDeselectItem(item) {
            this.setState(({ selectedItems }) => ({
                selectedItems: selectedItems.filter((t) => t[uniqueIdentifier] !== item[uniqueIdentifier]),
            }));
        }
        getInjectedProps(state) {
            const { selectedItems } = state;
            return this.memoizedGetInjectedProps(selectedItems);
        }
        memoizedGetInjectedProps(selectedItems) {
            return {
                selectedItems: selectedItems,
                setSelectedItems: this.handleSetSelectedItems,
                selectItem: this.handleSelectItem,
                deselectItem: this.handleDeselectItem,
            };
        }
        render() {
            return (_jsx(Component, Object.assign({}, this.props, { selection: this.getInjectedProps(this.state) })));
        }
    }
    __decorate([
        boundMethod
    ], WithSelection.prototype, "handleSetSelectedItems", null);
    __decorate([
        boundMethod
    ], WithSelection.prototype, "handleSelectItem", null);
    __decorate([
        boundMethod
    ], WithSelection.prototype, "handleDeselectItem", null);
    __decorate([
        boundMethod
    ], WithSelection.prototype, "getInjectedProps", null);
    return WithSelection;
};
